import {
  changeActiveObjectPropsOnSelected,
} from '@/components/Editor/helpers/fabric/activeObjects/changeActiveObjectProps';
import {
  saveUpdatedActiveObjectInStore,
} from '@/components/Editor/helpers/fabric/activeObjects/modifyActiveObjectInStore';
import { FabricCanvas } from '@/components/Editor/types/fabric';
import { ToggleTypes } from '@/types';

export const selectionUpdated = (
  canvas: FabricCanvas,
  toggle: ToggleTypes,
): void => {
  canvas[toggle]('selection:updated', changeActiveObjectPropsOnSelected);
  canvas[toggle]('selection:updated', saveUpdatedActiveObjectInStore);
};
